import { createFileRoute, redirect } from '@tanstack/react-router'
import { requireAuth } from './utils/auth-guards'

export const Route = createFileRoute('/')({
  beforeLoad: (ctx) => {
    requireAuth(ctx)

    if (!ctx.context?.auth?.isLoadingLogin) {
      throw redirect({ to: '/project' })
    }
  }
})
